// @ts-nocheck

import { css } from 'styled-components';

import grids from './grids';

export default {
  breakpoints: {
    sm: 1024, // min width of electron poker-client
    md: 1280,
    lg: 1366,
    xl: 1980,
  },
  common: {
    colors: {
      primary: '#b20e10', // red
      secondary: '#ffc514', // yellow
      lightSecondary: '#fffde0',
      gray: '#555',
      lightest: '#f2f2f2',
      lighter: '#e6e6e6',
      light: '#bfbfbf',
      mild: '#808080',
      dark: '#252525',
      dark2: '#272727',
      darker: '#1a1a1a',
      darkest: '#0d0d0d',
      positive: '#2abd2a',
      negative: '#ec414a',
      defaultFontColor: '#333',
      OddButtonDisabled: '#a9a9a9',
      headerColor: '#fff',
    },
    headerStyle: css`
      background-color: ${({ theme }) => theme.common.colors.dark};
      color: ${({ theme }) => theme.common.colors.headerColor};
      font-weight: bold;
      font-size: 12px;
      line-height: normal;
      padding: 5px;
      text-align: left;
      text-transform: uppercase;
    `,
    newHeaderStyle: css`
      background-color: ${({ theme }) => theme.common.colors.dark};
      color: ${({ theme }) => theme.common.colors.headerColor};
      text-transform: uppercase;
      font-weight: 600;
      font-size: 0.9em;
      line-height: normal;
      padding: 0.4em;
      text-align: left;
    `,
  },
  grids,
};
